module.exports = __webpack_public_path__ + "img/BellTower.7351cad4.jpg";